import { DSCardWrapper } from "@components/design-system/molecules";
import {
  DSInput,
  DSTextarea,
} from "@components/design-system/molecules";
import { Controller, useWatch } from "react-hook-form";

import FavoriteToggle from "../FavoriteToggle";
import WizardStep from "./WizardStep";

export default function NameAndSaveStep({
  control,
  onBack,
  onSave,
  saving = false,
}) {
  const name = useWatch({ control, name: "name" });

  return (
    <WizardStep
      title="Name Your Template"
      description="Last but not least...give your template a name and an optional description so you can find it later."
      onBack={onBack}
      onNext={onSave}
      nextLabel={saving ? "Saving..." : "Save Template"}
      nextDisabled={!name?.trim() || saving}
      dataTestId="wizard-step-name-save"
    >
      <div className="flex flex-col gap-md">
        <NameField control={control} />
        <DescriptionField control={control} />
        <DSCardWrapper variant="ghost">
          <FavoriteToggle control={control} />{" "}
          <p className="text-xs text-secondary mt-sm">
            Marking a template as a favorite will add the template to
            your the top of your template selection list for easy
            access later.
          </p>
        </DSCardWrapper>
      </div>
    </WizardStep>
  );
}

function NameField({ control }) {
  return (
    <Controller
      control={control}
      name="name"
      render={({ field: { onChange, value, ref } }) => (
        <DSInput
          label="Template Name"
          placeholder="e.g., General Consult, Wellness Exam"
          value={value || ""}
          onChange={onChange}
          ref={ref}
          required
          dataTestId="wizard-template-name-input"
        />
      )}
    />
  );
}

function DescriptionField({ control }) {
  return (
    <Controller
      control={control}
      name="description"
      render={({ field: { onChange, value, ref } }) => (
        <DSTextarea
          label="Description (optional)"
          placeholder="Briefly describe when to use this template..."
          value={value || ""}
          onChange={onChange}
          ref={ref}
          maxRows={3}
          dataTestId="wizard-template-description-input"
        />
      )}
    />
  );
}
